import { AppConfig, DEFAULT_FEATURES } from 'ut-business/shared';

export const oneutviewConfig: AppConfig = {
  appName: 'OneUtView',
  appIcon: 'wind-turbine',
  appInitials: 'OV',
  features: {
    ...DEFAULT_FEATURES,
    indication: {
      columns: [
        'viewTypeName',
        'configName',
        'measuredThickness',
        'materialLoss',
        'positionScan',
        'positionIndex',
        'length',
        'width',
        'flawType',
        'verdict',
        'details',
        'imageButton',
      ],
      detailReadings: [
        'sr',
        'ir',
        'ur',
        'zScanStart',
        'zScanEnd',
        'zIndexStart',
        'zIndexEnd',
      ],
      flawTypes: [
        'Foreign Object',
        'Porosity',
        'Thickness Deviation',
        'Position Deviation',
        'Bondline Deviation',
        'Horizontal Void',
        'Vertical Void',
      ],
    },
    analysis: true,
    aScanBitDepth: false,
    canAlignData: false,
    canStitchData: false,
    cScanThickness: true,
    deviceManager: true,
    dgs: false,
    dynamicGateMeasurementCursor: false,
    firingSequence: true,
    gateAndTcgSyncho: true,
    inspection: true,
    materialLossReading: true,
    mergeFiles: true,
    scannerMenu: true,
    snapToMinThickness: true,
    showStickynotes: true,
    snr: true,
    tcgReferenceAmplitudeLine: false,
    tilingCanvas: true,
    zoneStatistics: true,
  },
};
